import { render, staticRenderFns } from "./show.form.vue?vue&type=template&id=0e636d84&scoped=true"
import script from "./show.form.vue?vue&type=script&lang=js"
export * from "./show.form.vue?vue&type=script&lang=js"
import style0 from "./show.form.vue?vue&type=style&index=0&id=0e636d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e636d84",
  null
  
)

export default component.exports